'use client';

import { CampaignSliderProps } from '@/types/amplience';
import { SliderHeader } from '@/components/Slider/SliderHeader';
import { getModuleBackgroundStyles } from '@/utility/getModuleBackgroundStyles';
import { CampaignSliderContent } from '../CampaignSliderContent';

export default function CampaignSlider({
  content,
  className,
  isLazyLoadingOff,
}: {
  content: CampaignSliderProps;
  className?: string;
  isLazyLoadingOff?: boolean;
}) {
  const { bgClass, textColor } = getModuleBackgroundStyles(content.backgroundColor);

  return (
    <section className={`${className} ${bgClass}`}>
      <SliderHeader
        heading={content.heading}
        showAllLink={content.showAllLink}
        className={textColor}
      />
      <CampaignSliderContent
        items={content.items}
        cardVariant={content.cardVariant}
        backgroundColor={content.backgroundColor}
        isLazyLoadingOff={isLazyLoadingOff}
      />
    </section>
  );
}
